import { createFileRoute } from "@tanstack/react-router";
import { GraphCanvas } from "./-GraphCanvas";

function MiterSkeletonDebug() {
  return <GraphCanvas />;
}

export const Route = createFileRoute("/debug/geom/miter-skeleton/")({
  component: MiterSkeletonDebug,
});
